export default {"src":"/_next/static/media/user.2aaff458.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};